import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

export const fetchProductGlobalLimit = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PRODUCT_GLOBAL_LIMIT_LOADING,
			payload: true
		});

		const { data } = await services.get(`statistics/products/${id}/limits`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PRODUCT_GLOBAL_LIMIT_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PRODUCT_GLOBAL_LIMIT_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
